export const createVariants = body => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v1/ecom/variants/create`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        //   Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body),
    }
  )
    .then(response => {
      return response.json();
    })
    .catch(err => console.log(err));
};

export const updateVariant = (id, body) => {
  console.log(id,'........',body);
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v1/ecom/variants/update/${id}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  )
    .then(res => {
      console.log(res)
      return res.json();
    })
    .catch(e => console.log(`error at Variant update ${e}`));
};
export const getVariants = () => {
  return fetch(`${process.env.REACT_APP_DATABASEURL}/api/v1/ecom/variants/all`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      // Authorization: `Bearer ${token}`
    },
  })
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at get variants ${e}`));
};
export const deleteVariant=(id)=>{
  return fetch(`${process.env.REACT_APP_DATABASEURL}/api/v1/ecom/variants/delete/${id}`,{
      method:"DELETE",
      headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`
        },
  }).then(res=>{
      return res.json()
  }).catch(e=>console.log(`error at get variants ${e}`))  
}